// Client V2 common imports
const { wrapDisplayName } = require('client-v2/common/components/utils')
const tag = require('client-v2/common/utils/hyperscript')

function withIsVisible(wrappedComponent) {
  function IsVisible({ isVisible, ...props }) {
    if (isVisible) {
      return tag(wrappedComponent, props)
    }
    return null
  }
  IsVisible.displayName = wrapDisplayName('IsVisible', wrappedComponent)
  return IsVisible
}

module.exports = withIsVisible
